import React, { useState, useEffect, useCallback } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { SearchFilters } from "components/SearchFilters"
import { SearchResults } from "../components/SearchResults"
import { Pagination } from "../components/Pagination"
import useMedia from "hooks/useMedia.js"
import algoliasearch from "algoliasearch"
import useDidMountEffect from "hooks/useDidMountEffect"
import algoliaIndex from "utils/algoliaIndex"

const SearchPage = () => {
  const [searchQuery, setSearchQuery] = useState("")
  const [filters, setFilters] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [currentPosts, setCurrentPosts] = useState(null)
  const [totalPosts, setTotalPosts] = useState(null)
  const [totalPages, setTotalPages] = useState(0)
  const [facets, setFacets] = useState(null)
  const postsPerPage = 9
  const pageNumbersShown = useMedia(
    // Media queries
    ["(max-width: 767px)", "(min-width: 768px)"],
    //options
    [3, 5],
    // default
    5
  )
  const noQuery = !searchQuery.length && filters.length === 0

  const findResults = useCallback(() => {
    algoliaIndex.search(
      searchQuery,
      {
        page: currentPage - 1,
        hitsPerPage: postsPerPage,
        facetFilters: [filters.map(filter => `site: ${filter}`)],
        facets: ["site"],
      },

      (err, data = {}) => {
        if (err) throw err
        setCurrentPosts(data.hits)
        setTotalPosts(data.nbHits)
        setTotalPages(data.nbPages)
        setFacets(data.facets)
        console.log("data:", data)
      }
    )
  }, [currentPage, searchQuery, filters])

  useDidMountEffect(() => {
    if (noQuery) {
      setCurrentPosts(null)
      setTotalPosts(null)
      setTotalPages(null)
      setFacets(null)
    } else {
      findResults()
    }
  }, [findResults, noQuery])

  useDidMountEffect(() => {
    setCurrentPage(1)
  }, [searchQuery])

  const handleSearchUpdate = value => {
    setSearchQuery(value)
  }

  //get params
  useEffect(() => {
    if (typeof window !== `undefined`) {
      const urlParams = new URLSearchParams(window.location.search)
      const queryParam = urlParams.get("q")
      const pageParam = urlParams.get("p")
      const filtersParam = urlParams.getAll("f")

      if (queryParam) {
        setSearchQuery(queryParam)
        console.log("queryParam:", queryParam)
      }

      if (pageParam) {
        setCurrentPage(pageParam)
        console.log("pageParam:", pageParam)
      }

      if (filtersParam.length) {
        setFilters(filtersParam)
      }
    }
  }, [])

  return (
    <Layout
      handleSearchUpdate={handleSearchUpdate}
      searchQuery={searchQuery}
      search
      headerTitle="Search"
    >
      <SEO title="Search" />
      <SearchFilters
        facets={facets}
        totalPosts={totalPosts}
        setFilters={setFilters}
        filters={filters}
        noQuery={noQuery}
      />
      <SearchResults currentPosts={currentPosts} searchQuery={searchQuery} />
      {currentPosts ? (
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          pageNumbersShown={pageNumbersShown}
          totalPosts={totalPosts}
          postsPerPage={postsPerPage}
          query={searchQuery}
          setQuery={setSearchQuery}
        />
      ) : null}
    </Layout>
  )
}

export default SearchPage
